// Derives which resource the chat dock should treat as "open" (Task 4.1).
//
// Uses the URL path directly rather than useParams(): AiChatDock is mounted in
// AppLayout, a layout ancestor of the routed page (ListEditorPage etc. render
// inside its <Outlet/>), so useParams() there would not see a route param
// declared on a route nested deeper in the tree. Matching the path is the same
// technique web/src/lib/api.ts's resourceForPath already uses for this reason.

import { useLocation } from "react-router-dom";
import type { AiChatContextRef } from "@checklist/shared";

const RESOURCE_PATH = /^\/(lists|templates|checklists)\/([^/?]+)/;

export function useResourceContext(): AiChatContextRef | null {
  const { pathname } = useLocation();
  const match = pathname.match(RESOURCE_PATH);
  if (!match) return null;
  const id = decodeURIComponent(match[2]!);
  if (id === "new") return null;
  const kind =
    match[1] === "lists" ? "list" : match[1] === "templates" ? "template" : "checklist";
  return { kind, id };
}
